import React from "react";
import { useForm } from "react-hook-form";

const FormClientsDifusion = ({ handleSendDifusion }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    handleSendDifusion(data);
  };

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="mb-3">
          <label className="form-label">Asunto</label>
          <input
            type="text"
            className={`form-control ${errors.subject ? "is-invalid" : ""}`}
            placeholder="Asunto del mensaje..."
            {...register("subject", {
              required: "El asunto es obligatorio",
              minLength: {
                value: 3,
                message: "El asunto debe tener al menos 3 caracteres",
              },
            })}
          />
          <div className="invalid-feedback" style={{ minHeight: "20px" }}>
            {errors.subject?.message || ""}
          </div>
        </div>
        <div className="mb-3">
          <label className="form-label">Mensaje</label>
          <textarea
            className={`form-control ${errors.message ? "is-invalid" : ""}`}
            rows="4"
            placeholder="Escribe tu mensaje aquí..."
            {...register("message", {
              required: "El mensaje es obligatorio",
              minLength: {
                value: 10,
                message: "El mensaje debe tener al menos 10 caracteres",
              },
            })}
          ></textarea>
          <div className="invalid-feedback" style={{ minHeight: "20px" }}>
            {errors.message?.message || ""}
          </div>
        </div>
        <button type="submit" className="btn btn-primary col-12">
          Enviar difusión
        </button>
      </form>
    </div>
  );
};

export default FormClientsDifusion;
